export default __webpack_public_path__ + "static/brilliantly-warm-banner-2-92b39b3d3d1214c5953e4fd0edb6ac15.webp";